import {defineStore} from "pinia";
import logApi from "../api/log"

export const useLogStore = defineStore('log', {
    actions: {
        async createLog(data) {
            return await logApi.create(data)
        },
    }
})